import React, { useEffect, useState } from 'react'
import { Button, Container, FloatingLabel, Form } from 'react-bootstrap'
import Wrapper from '../../homeWrapper/Wrapper'
import './style.scss'
import SimpleReactValidator from 'simple-react-validator';
import { toast } from 'react-toastify'
import axios from 'axios';
import { fetchCsrfCookie } from '../../../redux/action/csrf/csrf-cookie';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

axios.defaults.withCredentials = true;

const ContactUs = () => {
    const [btnLoading, setBtnLoading] = useState(false)
    const [captcha, setCaptcha] = useState()
    const validator = new SimpleReactValidator()
    let dispatch = useDispatch()
    const lang = localStorage.getItem('lang')
    const {t} = useTranslation();

    const [select, setSelect] = useState({
        name: '',
        email: '',
        description: '',
        type: '',
        captcha: '',
        key: ''
    })

    useEffect(() => {
        dispatch(fetchCsrfCookie())
        axios.get('auth/captcha')
        .then(res => { 
            setCaptcha(res.data)
            setSelect({
                ...select,
                key: res.data.url.key
            })
         })
        .catch(err => console.log(err))
    }, [])

    const resetCaptcha = () => {
        setBtnLoading(true)

        axios.get('auth/captcha')
        .then(res => { 
            setBtnLoading(false)
            setCaptcha(res.data)
            setSelect({
                ...select,
                captcha: '',
                key: res.data.url.key
            })
         })
        .catch(err => {        
            setBtnLoading(false)
            console.log(err)
        })
    }

    const handleSelectChange = (event) => { 
        setSelect({ ...select, [event.target.name]: event.target.value })
    }

    const handleFormSubmit = (e) => {
        e.preventDefault()
        const key = captcha.url.key
        setBtnLoading(true)

        if (validator.allValid()) {
            axios.post('p/contact', select, key)
            .then( response => {
                setBtnLoading(false)
                if(response.data.verification === false ) {
                    resetCaptcha()
                    toast.dismiss()	
                    toast.error(t("toast_the_security_code_is_incorrect") , {position: 'bottom-right'}) 
                } 
                else if (response.data.verification === true) {
                    toast.dismiss()	
                    toast.success(t("toast_successfully_sent") , {position: 'bottom-right',className: 'foo-bar'})
                    setSelect({
                        name: '',
                        email: '',
                        description: '',
                        type: '',
                        captcha: '',
                        key: ''
                    })
                }
            })
            .catch(err => {
                setBtnLoading(false)
                if(err.message === "Request failed with status code 422") {
                   toast.dismiss()
                   toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})	
                }
            })
        } else {
            setBtnLoading(false)
            validator.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})	
        }
    }

    return (
        <Wrapper>
            <Helmet>
                <title>ارتباط با ما - نمایشگاه مجازی</title>
            </Helmet>
            <div className='contact-us-wrapper'>
                <Container>
                    <h5 className='home_title'> {t("contact-us")}:</h5>
                    <p className='mt-3'>{t("please fill out the form below and click on the Send Message button")}</p>

                    <div className='row'>
                        <div className='col-md-6 mt-3'>
                            <Form onSubmit={e => handleFormSubmit(e)}>
                                <FloatingLabel controlId="floatingInput" label={t("your name")}  className="mb-3" >
                                    <Form.Control value={select.name} name="name" type="text" placeholder="نام" onChange={handleSelectChange} />
                                    {validator.message('name', select.name, 'required')}
                                </FloatingLabel>

                                <FloatingLabel controlId="floatingInput" label={t("your email")} className="mb-3" >
                                    <Form.Control value={select.email} name="email" onChange={handleSelectChange} type="email" placeholder="ايميل" />
                                    {validator.message('email', select.email, 'required')}
                                </FloatingLabel>

                                <FloatingLabel controlId="floatingSelect" label={t("message subject")} className="mb-3">
                                    <Form.Select value={select.type} name="type" onChange={handleSelectChange} aria-label="Floating label select example">
                                        <option></option>
                                        <option value="پیشنهاد">{t("Offer")}</option>
                                        <option value="انتقاد">{t("criticism")}</option>
                                        <option value="شکایت">{t("complaints")}</option>
                                        <option value="تبلیغات">{t("advertising")}</option>
                                    </Form.Select>
                                    {validator.message('type', select.type, 'required')}
                                </FloatingLabel>

                                <FloatingLabel controlId="floatingTextarea" label={t("message")} className="mb-3">
                                    <Form.Control
                                        value={select.description} name="description" onChange={handleSelectChange} 
                                        as="textarea"
                                        style={{ minHeight: '150px' }}
                                    />
                                    {validator.message('description', select.description, 'required')}
                                </FloatingLabel>

                                <div className='row'>
                                    <FloatingLabel controlId="floatingInput"  label={t("Enter the value of the security code")}  className="col-md-7" >
                                        <Form.Control value={select.captcha} name="captcha" onChange={handleSelectChange} type="text" placeholder="کد امنیتی"  />
                                        {validator.message('captcha', select.captcha, 'required')}
                                    </FloatingLabel>
                                    <div className='col-md-5 captcha'>
                                        <img src={captcha ? captcha.url.img : ''} alt="captcha" />
                                        <span className='btn btn-outline-danger' onClick={resetCaptcha}><i className="fa fa-refresh" aria-hidden="true"></i></span>
                                    </div>
                                </div>
                                <Button type="submit" className='btn btn-primary my-4 px-5' disabled={btnLoading ? true : false}>{t("send")}</Button>
                            </Form>
                        </div>
                        <div className='col-md-5 offset-md-1 contact_logo'>
                            <img src="/assets/img/contact.png" alt="contact-us" />
                        </div>
                    </div>
                </Container>
            </div>
        </Wrapper>
    )
}

export default ContactUs
